
import { useMutation } from "react-query";
import sbiService from "../services/sbiService";

const useUpdatePayment = (onData) => {
    return useMutation(sbiService.updatePayment, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};


const sbiQueries = {
    useUpdatePayment,
};

export default sbiQueries
